/**
  Handles drop-down menus.
*/
export default function wpNavMenu() {

    const navMenu = document.getElementById('menu-global');
    const navMenuContainer = document.querySelector('.menuGlobal-container');
    let menuFitsChecked = false;
    let menuFits = false; 

    if(! navMenu || ! navMenuContainer) {
        console.log('Menu #menu-global not found');
        return;
    }

    const itemsWithChildren = navMenu.querySelectorAll('.menu-item-has-children');

    if(! itemsWithChildren.length) {
        return;
    }

    /*  adds a parent link for nav items with a submenu 

    let item;
    //let containerWidth = document.querySelector('.site-branding-top-strip').clientWidth;
    //Add "All" link to submenu that links to top level page
    itemsWithChildren.forEach( item => {
        let link = item.firstChild;
        let subMenu = item.querySelector('.sub-menu');
        console.log(item);
    //    subMenu.style.width = `${containerWidth}px`;

      //  li.innerHTML = `<a href="${link.href}">${link.textContent} - All</a>`;
      if(itemsWithChildren.length > 1) {
          let li = document.createElement('li');
          li.innerHTML = `<a href="${link.href}">Overview</a>`;
          subMenu.prepend(li);
      }
    }); */

    const lastItem = document.querySelector('#menuGlobal-list > li:last-child');

    // check to see if the menu fits without scrolling horizontally
    let observer = new IntersectionObserver(
        function (entries, observer) { 
            if(menuFitsChecked) {
                return; // only runs once on page load
            }

            entries.forEach(function(entry) {
                if(entry.isIntersecting){
                    menuFits = true;
                    console.log('menu fits running', menuFits)
                }
            });

            if(! menuFits) {
                navMenuContainer.classList.add('menu-does-not-fit');
            }

            menuFitsChecked = true;
        }, 
        {    
            root: navMenuContainer,
            rootMargin: '0px',
            threshold: 1.0
        }
    );

    observer.observe(lastItem);


  //  const compStyles = window.getComputedStyle(mobileHeaderEl);

  //  return compStyles.getPropertyValue('display') === 'flex';

    document.addEventListener('click', ev => {
 
        const itemWithSubmenuClicked = ev.target.closest('.menuGlobal .menu-item-has-children');

        // a click anywhere else in the document hides the submenu if displayed
        if(! itemWithSubmenuClicked) {
            itemsWithChildren.forEach( function(itemWithChildren) {
                itemWithChildren.classList.remove('show-sub-menu');
            });

            return;
        }

        // if link inside submenu clicked follow link
   
        if(ev.target.closest('.menuGlobal .sub-menu')) {
            return;
        }

        ev.preventDefault();

        const submenu = itemWithSubmenuClicked.querySelector('.sub-menu');
        const dims = itemWithSubmenuClicked.getBoundingClientRect();

        let left = Math.round(dims.left);
        let top =  Math.round(dims.bottom);

        if(screen.width - left < 250) {
            left = screen.width - 270;
        }

        if(left < 0) {
            left = 10;
        }
 
        submenu.style.left = left + 'px';
        submenu.style.top = top + 'px';

        itemWithSubmenuClicked.classList.toggle('show-sub-menu');
    });
}


